export default __webpack_public_path__ + "static/media/dp-world.0c1fb929.svg";